/**
 * Number of policies by four underwriting/ re-underwriting, by place of Residence of Insured Person
 */

import {
	isHongKongResident,
	hasLoadings,
	hasExclusions
} from "@/modules/reports/schemas/utils/"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 4 }
		},
		{
			s: { r: 1, c: 5 },
			e: { r: 1, c: 8 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template 07 - Number of policies by five underwriting/ re-underwriting, by place of Residence of Insured Person"
	],
	["Place of Residence", "Standard Plan", "", "", "", "Flexi Plan", "", "", ""],
	[
		"",
		"Standard Offer",
		"With Premium Loading only",
		"With CBE only",
		"With Premium Loading and CBE",
		"Standard Offer",
		"With Premium Loading only",
		"With CBE only",
		"With Premium Loading and CBE"
	]
]

const rows = payload => [
	[
		"Hong Kong",
		countStandardOffer(true, payload),
		countOfferWithLoadings(true, payload),
		countOfferWithExclusions(true, payload),
		countOfferWithLoadingsAndExclusions(true, payload),
		0,
		0,
		0,
		0
	],
	[
		"Others",
		countStandardOffer(false, payload),
		countOfferWithLoadings(false, payload),
		countOfferWithExclusions(false, payload),
		countOfferWithLoadingsAndExclusions(false, payload),
		0,
		0,
		0,
		0
	]
]

const countStandardOffer = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let insuredPlaceOfResidence = isHongKongResident(
			policy.contractInsured[0].addresses
		)
		if (
			policy.status === "ISSUED" &&
			insuredPlaceOfResidence === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadings = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		if (
			policy.status === "ISSUED" &&
			loadings === true &&
			exclusions === false &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}

const countOfferWithExclusions = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let exclusions = hasExclusions(policy)
		let loadings = hasLoadings(policy)
		if (
			policy.status === "ISSUED" &&
			exclusions === true &&
			loadings === false &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadingsAndExclusions = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let resident = isHongKongResident(policy.contractInsured[0].addresses)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		if (
			policy.status === "ISSUED" &&
			loadings &&
			exclusions &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}
